import { Alert, Stack, Table, Text } from '@mantine/core';
import { IconInfoCircle } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import { PublicationImpactFactor as MetricsType } from '@/module/Journal';

export interface PublicationImpactFactorProps {
  data: MetricsType;
  hideTemporary?: boolean;
}

export function PublicationImpactFactor({ data, hideTemporary }: PublicationImpactFactorProps) {
  const { metrics, journal, rank, temporary } = data;
  const { t } = useTranslation();

  if (journal == null) {
    return (
      <Text
        c="dimmed"
        fs="italic"
      >
        {t('journals.impact.missingParams')}
      </Text>
    );
  }

  if (metrics == null) {
    return (
      <Text
        c="dimmed"
        fs="italic"
      >
        {t('journals.impact.noMetrics')}
      </Text>
    );
  }

  return (
    <Stack>
      {!hideTemporary && temporary && (
        <Alert
          color="yellow"
          title={t('journals.impact.temporary.title')}
          icon={<IconInfoCircle />}
        >
          {t('journals.impact.temporary.content')}
        </Alert>
      )}
      {rank != null && (
        <Text>{`Cea mai bună încadrare este pentru anul ${rank.year}, categoria ${rank.wosCategory?.name}, index ${rank.wosIndex?.name} in ${rank.quarterly}, rank ${rank.rank} din ${rank.rankOf}`}</Text>
      )}
      <Table
        variant="vertical"
        layout="fixed"
        withTableBorder
        bg="white"
      >
        <Table.Tbody>
          <Table.Tr>
            <Table.Th w={350}>{journal.wosId ?? journal.title}</Table.Th>
            <Table.Td fw="500">{metrics.year}</Table.Td>
          </Table.Tr>

          <Table.Tr>
            <Table.Th>{t('journals.impact.jif')}</Table.Th>
            <Table.Td>{metrics.impactFactor}</Table.Td>
          </Table.Tr>

          <Table.Tr>
            <Table.Th>{t('journals.impact.jifWithoutSelfCitations')}</Table.Th>
            <Table.Td>{metrics.impactFactorWithoutSelfCitations}</Table.Td>
          </Table.Tr>

          <Table.Tr>
            <Table.Th>{t('journals.impact.jif5Years')}</Table.Th>
            <Table.Td>{metrics.impactFactor5Years}</Table.Td>
          </Table.Tr>
        </Table.Tbody>
      </Table>
    </Stack>
  );
}
